import api from "./axios";

export const registerUser = (data) => api.post("/api/auth/register/", data);

export const loginUser = (data) => api.post("/api/auth/login/", data);

export const googleLogin = (id_token) =>
  api.post("/api/auth/google/", { id_token });

export const getProfile = (token) =>
  api.get("/api/auth/me/", {
    headers: { Authorization: `Bearer ${token}` },
  });
